import { Tag } from "./S3files/AddDeviceModal";
import { SensorConfig } from "./S3files/FieldsConfiguration";

export interface DeviceApiData {
  device_data: DeviceData[];
  id: string;
}

export interface DeviceData {
  deviceID?: string;
  organization: string;
  // installationTime: string
  // location: string
  // deviceType: string
  firmwareVersion: string;
  mac_address: string;
  tags: Tag[]; // Add the tags field
  deviceType: string;
}

export interface Org {
  id?: string;
  name: string;
  description: string;
  location: string;
  view?: OrgView;
  owner_id: string;
}
export interface OrgView {
  owner_id: string;
}

export interface UpdatePayload {
  deviceID: string;
}

export const CrateOrgApi = async (data: Org) => {
  data = { ...data, owner_id: "adminid" };
  const myHeaders = new Headers();

  myHeaders.append("Content-Type", "application/json");

  const requestOptions: RequestInit = {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify(data),
  };

  try {
    const response = await fetch(`mqttapi/v1/session`, requestOptions);

    if (!response.ok) {
      throw new Error("Request failed with status " + response.status);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    return null;
  }
};

export const GetAllOrg = async () => {
  const myHeaders = new Headers();

  const requestOptions: RequestInit = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };

  try {
    const response = await fetch(`mqttapi/v1/sessions`, requestOptions);

    if (!response.ok) {
      throw new Error("Request failed with status " + response.status);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    return null;
  }
};

export const DeleteOrg = async (id: string) => {
  const myHeaders = new Headers();

  const requestOptions: RequestInit = {
    method: "DELETE",
    headers: myHeaders,
  };

  try {
    const response = await fetch(`mqttapi/v1/session/${id}`, requestOptions);

    if (!response.ok) {
      throw new Error("Request failed with status " + response.status);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    return null;
  }
};

export const UpdateOrgApi = async (data: any) => {
  const myHeaders = new Headers();

  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify(data);

  const requestOptions: RequestInit = {
    method: "PUT",
    headers: myHeaders,
    body: raw,
  };

  try {
    const response = await fetch(`mqttapi/v1/session`, requestOptions);

    if (!response.ok) {
      throw new Error("Request failed with status " + response.status);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    return null;
  }
};

export const GetAllVersions = async () => {
  const myHeaders = new Headers();

  const requestOptions: RequestInit = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };

  try {
    const response = await fetch(
      `${window.location.origin}/api/allVersions`,
      requestOptions
    );

    if (!response.ok) {
      throw new Error("Request failed with status " + response.status);
    }

    const result = await response.json();

    // Ensure result is an array; return empty array if not
    return Array.isArray(result) ? result : [];
  } catch (error) {
    throw error;
  }
};
export const GetVersionsByDeviceId = async (deviceID: string) => {
  const myHeaders = new Headers();

  const requestOptions: RequestInit = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };

  try {
    const response = await fetch(
      `${window.location.origin}/api/allVersions/${deviceID}`,
      requestOptions
    );

    if (!response.ok) {
      throw new Error("Request failed with status " + response.status);
    }

    const result = await response.json();

    // Ensure result is an array; return empty array if not
    return result;
  } catch (error) {
        throw error; // ❌ don't swallow errors, let the caller handle them

  }
};
export const GetDashboardData = async () => {
  const myHeaders = new Headers();

  const requestOptions: RequestInit = {
    method: "GET",
    headers: myHeaders,
    redirect: "follow",
  };

  try {
    const response = await fetch(
      `${window.location.origin}/api/dashboard`,
      requestOptions
    );

    if (!response.ok) {
      throw new Error("Request failed with status " + response.status);
    }

    const result = await response.json();

    // Ensure result is an array; return empty array if not
    return result;
  } catch (error) {
    throw error;
  }
};
export const UploadFile = async (
  fileInput: any,
  versionName: string,
  description: string,
  //  deviceType: string
  deviceID: string,
  tag: string[]
) => {
  const myHeaders = new Headers();

  var formdata = new FormData();
  formdata.append("file", fileInput[0], "firmware.bin");
  formdata.append("version", versionName);
  formdata.append("description", description);
  // formdata.append("deviceType", deviceType);
  formdata.append("deviceID", deviceID);
  formdata.append("tag", JSON.stringify(tag));

  const requestOptions: RequestInit = {
    method: "POST",
    headers: myHeaders,
    body: formdata,
    redirect: "follow",
  };

  try {
    const response = await fetch(`api/uploadFile`, requestOptions);

    if (!response.ok) {
      throw new Error("Request failed with status " + response.status);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};

export const DeleteDevice = async (DeviceId: string) => {
  const requestOptions: RequestInit = {
    method: "DELETE",
  };

  try {
    const response = await fetch(`api/device/${DeviceId}`, requestOptions);

    if (!response.ok) {
      throw new Error("Request failed with status " + response.status);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};

export const DeleteFile = async (fileName: string, deviceID: string) => {
  const requestOptions: RequestInit = {
    method: "GET",
    redirect: "follow",
  };

  try {
    const response = await fetch(
      `api/deleteFile?deviceID=${deviceID}&path=${fileName}`,
      requestOptions
    );

    if (!response.ok) {
      throw new Error("Request failed with status " + response.status);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};

export const DownloadFile = async (fileName: string, deviceId: string) => {
  try {
    // Make the request with credentials to include cookies
    const response = await fetch(`file/local-download?deviceType=${deviceId}&path=${fileName}`, {
      method: 'GET',
      credentials: 'include', // This includes cookies in the request
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error(`HTTP error! status: ${response.status}`);
    }

    // Get the blob from the response
    const blob = await response.blob();
    
    // Create a temporary URL for the blob
    const url = window.URL.createObjectURL(blob);
    
    // Create a temporary anchor element to trigger download
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName; // Set the filename for download
    
    // Append to body, click, and remove
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    
    // Clean up the temporary URL
    window.URL.revokeObjectURL(url);
    
    return true;
  } catch (error) {
    console.error('Download failed:', error);
    return null;
  }
};

export interface DeviceParams {
  page?: number;
  limit?: number;
  search?: string;
  orgFilter?: "true" | "false"; // optional
}
export const GetDeviceData = async (params: DeviceParams = {}) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  const requestOptions: RequestInit = {
    method: "GET",
    redirect: "follow",
    headers: myHeaders,
  };

  const url = `${window.location.origin}/api/device/all`;

  try {
    const response = await fetch(url, requestOptions);

    if (!response.ok) {
      throw new Error("Request failed with status " + response.status);
    }

    const result = await response.json(); // Expecting: { devices, total, page, total_pages, limit }
    return result;
  } catch (error) {
    console.log("error", error);
    return { devices: [], total: 0, page: 1, limit: 10, total_pages: 1 };
  }
};
export const GetDeviceByFilter = async (params: DeviceParams = {}) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  const requestOptions: RequestInit = {
    method: "GET",
    redirect: "follow",
    headers: myHeaders,
  };

  // Build query string
  const query = new URLSearchParams();

  if (params.page) query.append("page", params.page.toString());
  if (params.limit) query.append("limit", params.limit.toString());
  if (params.search) query.append("search", params.search);
  if (params.orgFilter !== undefined)
    query.append("orgFilter", params.orgFilter);

  const queryString = query.toString();
  const url = `${window.location.origin}/api/device/by-filter${
    queryString ? `?${queryString}` : ""
  }`;

  try {
    const response = await fetch(url, requestOptions);

    if (!response.ok) {
      throw new Error("Request failed with status " + response.status);
    }

    const result = await response.json(); // Expecting: { devices, total, page, total_pages, limit }
    return result;
  } catch (error) {
    console.log("error", error);
    return { devices: [], total: 0, page: 1, limit: 10, total_pages: 1 };
  }
};

export const GetDeviceList = async (params: DeviceParams = {}) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  const requestOptions: RequestInit = {
    method: "GET",
    redirect: "follow",
    headers: myHeaders,
  };

  // Build query string
  const query = new URLSearchParams();

  if (params.page) query.append("page", params.page.toString());
  if (params.limit) query.append("limit", params.limit.toString());
  if (params.search) query.append("search", params.search);
  if (params.orgFilter !== undefined)
    query.append("orgFilter", params.orgFilter);

  const queryString = query.toString();

  const urlList = `${window.location.origin}/api/device/list${
    queryString ? `?${queryString}` : ""
  }`;

  try {
    const response = await fetch(urlList, requestOptions);

    if (!response.ok) {
      throw new Error("Request failed with status " + response.status);
    }

    const result = await response.json(); // Expecting: { devices, total, page, total_pages, limit }
    return result;
  } catch (error) {
    console.log("error", error);
    return { devices: [], total: 0, page: 1, limit: 10, total_pages: 1 };
  }
};
export const AddDeviceApi = async (data: DeviceData) => {
  const myHeaders = new Headers();

  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({
    action: "add",
    payload: data,
  });

  const requestOptions: RequestInit = {
    method: "POST",
    headers: myHeaders,
    body: raw,
  };

  try {
    const response = await fetch(`api/device/add`, requestOptions);

    if (!response.ok) {
      throw new Error("Request failed with status " + response.status);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};

export const UdateDeviceApi = async (data: any) => {
  const myHeaders = new Headers();

  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify(data);

  const requestOptions: RequestInit = {
    method: "POST",
    headers: myHeaders,
    body: raw,
  };

  try {
    const response = await fetch(`api/device/update`, requestOptions);

    if (!response.ok) {
      throw new Error("Request failed with status " + response.status);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};

export const UpdateDeviceOrgApi = async (data: any) => {
  const myHeaders = new Headers();

  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify(data);

  const requestOptions: RequestInit = {
    method: "POST",
    headers: myHeaders,
    body: raw,
  };

  try {
    const response = await fetch(`api/device/org/update`, requestOptions);

    if (!response.ok) {
      throw new Error("Request failed with status " + response.status);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};

export const UpdateDeviceTagsApi = async (data: any) => {
  const myHeaders = new Headers();

  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify(data);

  const requestOptions: RequestInit = {
    method: "POST",
    headers: myHeaders,
    body: raw,
  };

  try {
    const response = await fetch(`api/device/tags/update`, requestOptions);

    if (!response.ok) {
      throw new Error("Request failed with status " + response.status);
    }

    const result = await response.text();
    return result;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};

export const CheckDeviceUpdateStatusApi = async (deviceId: string) => {
  const myHeaders = new Headers();

  myHeaders.append("Content-Type", "application/json");

  const requestOptions: RequestInit = {
    method: "GET",
    headers: myHeaders,
  };

  try {
    const response = await fetch(
      `api/device/update/status/${deviceId}`,
      requestOptions
    );

    if (!response.ok) {
      throw new Error("Request failed with status " + response.status);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};
export const ReconnectDevice = async (data: any) => {
  const myHeaders = new Headers();

  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({ deviceID: data });

  const requestOptions: RequestInit = {
    method: "POST",
    headers: myHeaders,
    body: raw,
  };

  try {
    const response = await fetch(`api/device/reconnect`, requestOptions);

    if (!response.ok) {
      throw new Error("Request failed with status " + response.status);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};

export const DisconnectDevice = async (data: any) => {
  const myHeaders = new Headers();

  myHeaders.append("Content-Type", "application/json");

  var raw = JSON.stringify({ deviceID: data });

  const requestOptions: RequestInit = {
    method: "POST",
    headers: myHeaders,
    body: raw,
  };

  try {
    const response = await fetch(`api/device/disconnect`, requestOptions);

    if (!response.ok) {
      throw new Error("Request failed with status " + response.status);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};

export const AddNewDeviceTypeApi = async (data: any) => {
  const myHeaders = new Headers();

  myHeaders.append("Content-Type", "application/json");

  const requestOptions: RequestInit = {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify(data),
  };

  try {
    const response = await fetch(`api/device/type/add`, requestOptions);

    if (!response.ok) {
      throw new Error("Request failed with status " + response.status);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};

export const UploadYaml = async (endpoint: string, data: any) => {
  const myHeaders = new Headers();

  const requestOptions: RequestInit = {
    method: "POST",
    headers: myHeaders,

    body: JSON.stringify(data),
  };
  myHeaders.append("Content-Type", "application/json");

  try {
    const response = await fetch(`${endpoint}`, requestOptions);

    if (!response.ok) {
      throw new Error("Request failed with status " + response.status);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};
export const FetchDeployments = async (endpoint: string) => {
  const requestOptions: RequestInit = {
    method: "GET",
  };

  try {
    const response = await fetch(`${endpoint}`, requestOptions);

    if (!response.ok) {
      throw new Error("Request failed with status " + response.status);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};

export const UpdateDeviceConfig = async (data: string, deviceId: string) => {
  const myHeaders = new Headers();

  myHeaders.append("Content-Type", "application/json");

  const requestOptions: RequestInit = {
    method: "POST",
    headers: myHeaders,
    body: data,
  };

  try {
    const response = await fetch(
      `api/device/command/${deviceId}`,
      requestOptions
    );

    if (!response.ok) {
      throw new Error("Request failed with status " + response.status);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.log("error", error);
    return null;
  }
};

export const GetDeviceHistory = async (deviceId: string) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  const requestOptions: RequestInit = {
    method: "GET",
    redirect: "follow",
    headers: myHeaders,
  };

  try {
    const response = await fetch(
      `${window.location.origin}/device/${deviceId}/history`,
      requestOptions
    );

    if (!response.ok) {
      throw new Error("Request failed with status " + response.status);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.log("error", error);
    return error;
  }
};

/**
 * Fetches the connection status of a device within an optional time range.
 *
 * @param {string} deviceId - The unique identifier of the device.
 * @param {string} [from] - Optional ISO date string for the start of the time range.
 * @param {string} [to] - Optional ISO date string for the end of the time range.
 */
export const GetDeviceStatus = async (
  deviceId: string,
  from?: string,
  to?: string
) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  const params = new URLSearchParams();
  if (from) params.append("from", from);
  if (to) params.append("to", to);

  const url = `${window.location.origin}/device/${deviceId}/connect-status${
    params.toString() ? `?${params.toString()}` : ""
  }`;

  const requestOptions: RequestInit = {
    method: "GET",
    redirect: "follow",
    headers: myHeaders,
  };

  try {
    const response = await fetch(url, requestOptions);

    if (!response.ok) {
      throw new Error("Request failed with status " + response.status);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.log("GetDeviceStatus error:", error);
    return error;
  }
};

/**
 * Sends field configuration data to the server for a specific device.
 * 
 * @param payload The object containing device_id and its associated slave/field configurations.
 * @returns API response or error
 */
export const SendDeviceFields = async (payload: {
  device_id: string;
  data: SensorConfig[];
}) => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  const requestOptions: RequestInit = {
    method: "POST",
    headers: myHeaders,
    body: JSON.stringify(payload),
    redirect: "follow",
  };

  try {
    const response = await fetch(`${window.location.origin}/device-fields`, requestOptions);

    if (!response.ok) {
      throw new Error("Request failed with status " + response.status);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.log("SendDeviceFields error", error);
    return error;
  }
};

/**
 * Fetches the field history for a specific device by its ID.
 *
 * @param {string} deviceId - The unique identifier of the device.
 * @returns {Promise<any>} The JSON response containing device field history or an error object.
 */
export const GetDeviceFieldsHistory = async (deviceId: string): Promise<any> => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  const requestOptions: RequestInit = {
    method: "GET",
    redirect: "follow",
    headers: myHeaders,
  };

  try {
    const response = await fetch(
      `${window.location.origin}/device-fields/${deviceId}`,
      requestOptions
    );

    if (!response.ok) {
      throw new Error("Request failed with status " + response.status);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.log("error", error);
    return error;
  }
};

/**
 * Updates the fields of a specific device using its ID and a provided payload.
 *
 * @param {string} deviceId - The unique identifier of the device.
 * @param {any} payload - The data to update for the device fields.
 * @returns {Promise<any>} The JSON response after update or an error object.
 */
export const UpdateDeviceFields = async (deviceId: string, payload: any): Promise<any> => {
  const myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");

  const requestOptions: RequestInit = {
    method: "PUT",
    headers: myHeaders,
    redirect: "follow",
    body: JSON.stringify(payload),
  };

  try {
    const response = await fetch(
      `${window.location.origin}/device-fields`,
      requestOptions
    );

    if (!response.ok) {
      throw new Error("Update request failed with status " + response.status);
    }

    const result = await response.json();
    return result;
  } catch (error) {
    console.log("update error", error);
    return error;
  }
};
